export enum PostLayout {
  Large,
  Regular,
  Minimal,
  List
}
